import { Routes, Route, Navigate } from "react-router-dom";

// import Aviation from "./Aviation";
import MMS from "./MMS";

const mmsRoutes = [
     {routeName: 'digital-printing' , component: <MMS/>},
     {routeName: 'normal-bulk-shipment' , component: <MMS/>},
     {routeName: 'automatic-stuffing' , component: <MMS/>},
     {routeName: 'mail-room-management' , component: <MMS/>},
     {routeName: 'bulk-mail-project' , component: <MMS/>},
     {routeName: 'delivery' , component: <MMS/>},
     {routeName: 'customized-solutions' , component: <MMS/>},
    //  {routeName: 'air-cargo' , component: <Aviation/>},
    //  {routeName: 'chartered' , component: <Aviation/>},
    //  {routeName: 'rush-delivery' , component: <Aviation/>},
     

];

const MMSRoutes = () => {
    return (
    <Routes>
       {mmsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default MMSRoutes;